import { html, LitElement, PropertyDeclarations, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";

import * as Tags from "./user-menus.tagnames";
import { findCssRules, getGlobalStyleSheets } from "../../global-styles";

const HEADER_OPTIONS_SLOT = "HeaderOptions";
const HEADER_TITLE_INDICATOR_SLOT = "HeaderTitleIndicator";

@customElement(Tags.UserNotificationsPanelSection)
export class AtlUserNotificationsPanelSection extends LitElement {
  declare headerTitle?: string;
  declare headerOptionsUsed?: boolean;

  static styles = [
    ...getGlobalStyleSheets(),
    unsafeCSS(findCssRules(".notification-panel-section")),
  ];

  static properties: PropertyDeclarations = {
    headerTitle: { type: String },
    headerOptionsUsed: { type: Boolean, state: true },
  };

  private _onHeaderOptionsSlotChange = () => {
    const slot = this.shadowRoot?.querySelector(
      `slot[name=${HEADER_OPTIONS_SLOT}]`
    );

    const assignedNodes = (slot as HTMLSlotElement)?.assignedNodes({
      flatten: true,
    });
    this.headerOptionsUsed = assignedNodes?.length > 0;

    if (this.headerOptionsUsed) {
      const div = document.createElement("div");
      div.classList.add("panel-section-header-options");

      assignedNodes?.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          div.appendChild(node);
        }
      });
      slot?.parentNode!.replaceChild(div, slot);
    }
  };

  private _renderHeader = () => {
    if (!this.headerTitle && !this.headerOptionsUsed) {
      return html`
        <slot name="${HEADER_TITLE_INDICATOR_SLOT}"></slot>
        <slot
          name="${HEADER_OPTIONS_SLOT}"
          @slotchange=${this._onHeaderOptionsSlotChange}
        ></slot>
      `;
    }

    return html`
      <div class="panel-section-header">
        <div class="panel-section-header-title">
          ${this.headerTitle}
          <slot name="${HEADER_TITLE_INDICATOR_SLOT}"></slot>
        </div>
        <slot
          name="${HEADER_OPTIONS_SLOT}"
          @slotchange=${this._onHeaderOptionsSlotChange}
        ></slot>
      </div>
    `;
  };

  render() {
    return html`
      <section class="notification-panel-section">
        ${this._renderHeader()}
        <slot name="Articles"></slot>
      </section>
    `;
  }
}
